<template>
  <div>
    <div class="index__wrapper">
      <div class="navigator" v-if="showNavigator && allList.length">
        <ul>
          <li
            :class="show == index ? 'active' : ''"
            v-for="(item, index) in allList"
            :key="index"
            @click="toview(index)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="index__banner" v-if="imgList && imgList.length">
        <el-carousel :interval="200000" height="320px" trigger="click">
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <img :src="item.adImg" alt class="bannerImg" @click="jump(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div v-if="!nodata">
        <div class="index__items">
          <div
            class="index__item"
            v-for="(item, index) in menuList"
            :key="index"
            @click="item.isExist != 0 && toList(item.id, item.parentid)"
          >
            <div class="index__top">
              <img :src="item.imgUrl" alt />
              <div class="flag" v-if="item.isExist == 0">
                <img :src="!CheckCN() ? enTag : tag" alt="" />
              </div>
            </div>
            <div class="index__item-name">{{ TLang(item.name, "home") }}</div>
          </div>
        </div>
        <div>
          <listStyle
            ref="tops0"
            :info="selection"
            id="tops0"
            scroll-behavior="smooth"
          ></listStyle>
          <secondStyle
            class="index__second"
            v-for="(item, index) in homeShowList"
            :key="index"
            :info="item"
            :ref="`tops${index + 1}`"
            :id="`tops${index + 1}`"
            scroll-behavior="smooth"
          ></secondStyle>
        </div>
      </div>
      <div v-else>
        <div class="noData">
          <img src="@/assets/imgs/citynodata.png" alt="" />
        </div>
        <div class="font" style="line-height: 17px">
          {{ TLang("当前城市暂无演出信息", "my") }}
        </div>
        <div class="font" style="line-height: 17px">
          {{ TLang("如有疑问请联系", "my")
          }}<span style="color: #333333; font-weight: bold">{{ tel }}</span>
        </div>
        <div class="allbtn" @click.stop="$bus.$emit('changeCity')">
          {{ TLang("切换城市", "list") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listStyle from "@/components/index/listStyle1";
import secondStyle from "@/components/index/listStyle2";
import { mapMutations } from "vuex";
import { unionFlag } from "@/utils";
import { setTitleInfo } from "@/utils/title";
import Tag from "@/assets/imgs/index/tag.png";
import EnTag from "@/assets/imgs/index/tag_en.png";
import { getCookie } from "@/utils";
export default {
  name: "home",
  data() {
    return {
      showNavigator: false,
      show: 0,
      scrollTopList: [], // 所有列表部分高度集合
      imgList: [], //轮播图
      menuList: [], //顶部iconList
      selection: {}, // 演出精选
      homeShowList: [], //首页下面的列表
      allList: [],
      load_switch: null,
      nodata: false,
      tel: unionFlag() ? "400-618-2999" : "400-003-1010",
      CookiesOne: getCookie("df_lang"),
      enTag: EnTag,
      tag: Tag,
    };
  },
  components: {
    listStyle,
    secondStyle,
  },
  created() {
    this.loadingShow();
    setTitleInfo();
    // this.toList();
    const union = unionFlag();
    if (union && union !== "stage") {
      this.apis.home.getBili().then((data) => {
        if (data.respCode === "00000000") {
          this.setUnionInfo(data);
        }
        this.getImgs();
        this.getKindList();
        this.getHomeShowList();
      });
    } else {
      this.setUnionInfo({});
      this.getImgs();
      this.getKindList();
      this.getHomeShowList();
    }
  },
  methods: {
    //加载动画
    loadingShow() {
      // debugger
      this.load_switch = this.$loading({
        lock: true,
      });
    },
    loadingHidden() {
      this.load_switch.close();
    },
    ...mapMutations(["setUnionInfo"]),
    jump(item) {
      if (unionFlag()) {
        window.df_sdk_common.location.href =
          item.bfdUrl + "&union=" + unionFlag();
      } else {
        window.df_sdk_common.location.href = item.adUrl;
      }
    },
    toview(index) {
      window.scrollTo({
        top: this.scrollTopList[index],
        behavior: "smooth",
      });
    },
    getImgs() {
      this.apis.home.getImgs({ platform: 0 }).then((res) => {
        this.imgList = res.body;
      });
    },
    getKindList() {
      this.apis.home
        .getKindsList({
          city: Number(this.$route.query.city),
          channel: "6",
        })
        .then((res) => {
          if (res.body) {
            this.menuList = res.body.concat([
              {
                id: "",
                parentId: "",
                imgUrl:
                  "http://devimg.dongfangfuli.com/mall/upload/image_temp/2019-11/da016b5e-489a-4c88-bacd-f445b51f9ba3.png",
                name: TLang("全部", "home"),
                status: 1,
              },
            ]);
          } else {
            this.menuList = [];
          }
        });
    },
    getHomeShowList() {
      this.apis.home
        .getHomeShowlist({ city: Number(this.$route.query.city) })
        .then((res) => {
          if (res.body.length) {
            res.body = res.body.filter(
              (item) => item.searches && item.searches.length
            );
            this.allList = res.body;
            // 删除过期数据
            if (
              res.body[0] &&
              res.body[0].searches &&
              res.body[0].searches.length > 0
            ) {
              res.body[0].searches = this.deleteUnUsable(res.body[0].searches);
              if (res.body[0].searches.length <= 0) {
                this.allList.splice(0, 1);
              }
            }
            this.selection = res.body[0] || {};
            this.homeShowList = JSON.parse(JSON.stringify(res.body));
            this.homeShowList.splice(0, 1);
            if (this.homeShowList.length > 0) {
              for (var i = 0; i < this.homeShowList.length; i++) {
                this.homeShowList[i].searches = this.deleteUnUsable(
                  this.homeShowList[i].searches
                );
                if (this.homeShowList[i].searches.length <= 0) {
                  this.allList.map((con, showIndex) => {
                    if (con.title == this.homeShowList[i].title) {
                      this.allList.splice(showIndex, 1);
                    }
                  });
                }
              }
            }
            this.nodata = false;
          } else {
            this.nodata = true;
          }
          this.loadingHidden();
        });
    },
    deleteUnUsable(searches) {
      searches.map((list, index) => {
        if (!list.usable) {
          searches.splice(index, 1);
          this.deleteUnUsable(searches);
          return;
        }
      });
      return searches;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= this.$refs.tops0.$el.offsetTop) {
        this.showNavigator = true;
      } else {
        this.showNavigator = false;
      }
      let scrollTopList = [];
      this.allList &&
        this.allList.forEach((value, index) => {
          if (index == 0) {
            scrollTopList.push(this.$refs.tops0.$el.offsetTop + 170); // 170为头部距离，为何获取不到原因不详
          } else {
            if (this.$refs[`tops${index}`] && this.$refs[`tops${index}`][0]) {
              scrollTopList.push(
                this.$refs[`tops${index}`][0].$el.offsetTop + 170
              );
            }
          }
        });
      this.scrollTopList = scrollTopList;
      if (this.showNavigator) {
        scrollTopList.forEach((value, index) => {
          if (
            index != scrollTopList.length - 1 &&
            value <= scrollTop &&
            scrollTop < scrollTopList[index + 1]
          ) {
            this.show = index;
          } else if (index == scrollTopList.length - 1 && value <= scrollTop) {
            this.show = index;
          }
        });
      }
    },
    toList(categoryId, parentId) {
      this.$router.push({
        path: "/list",
        query: {
          categoryId,
          parentId,
        },
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>

<style lang="less" scoped>
.allbtn {
  background: #3FA6FF;
  background: var(--df-primary-color, #3FA6FF);
  width: 100px;
  height: 34px;
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 34px;
  border-radius: 2px;
  margin: 26px auto;
  margin-bottom: 93px;
  cursor: pointer;
}
.noData {
  width: 216px;
  margin: 93px auto;
  margin-bottom: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.font {
  text-align: center;
  color: #999999;
  font-size: 12px;
  line-height: 31px;
}
.index__wrapper {
  padding-bottom: 30px;
}
.bannerImg {
  width: 100%;
  height: 100%;
}
.index__banner {
  /deep/.el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.3);
    width: 48px;
    height: 48px;
    transition: none;
    &.el-carousel__arrow--left {
      left: 32px;
    }
    &.el-carousel__arrow--right {
      right: 32px;
    }
  }
  /deep/.el-carousel__arrow:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }
  /deep/.el-carousel__arrow i {
    font-size: 20px;
  }
  /deep/.el-carousel__arrow.el-carousel__arrow--right i {
    // margin-left: 2px;
  }
}
.index__ {
  &wrapper {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  &banner {
    height: 320px;
    width: 100%;
  }
  &items {
    height: 90px;
    margin: 65px 0;
    overflow: hidden;
  }
  &item {
    width: 80px;
    float: left;
    text-align: center;
    margin-left: 44px;
    cursor: pointer;
  }
  &item:nth-child(1) {
    margin-left: 0;
  }
  &item-name {
    width: 100%;
    text-align: center;
    font-size: 20px;
    line-height: 26px;
    margin-top: 12px;
    color: #222222;
  }
  &top {
    width: 52px;
    height: 52px;
    margin-left: 14px;
    position: relative;
    img {
      width: 100%;
    }
    .flag {
      width: 60px;
      position: absolute;
      top: 0;
      left: 30px;
      height: 20px;
    }
  }
  &second {
    margin-top: 70px;
  }
}
.navigator {
  width: 72px;
  position: fixed;
  top: 164px;
  left: calc(50% - 696px);
  box-shadow: 0px 3px 6px 0px rgba(53, 59, 64, 0.06);
  ul li {
    height: 32px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  ul li:nth-child(1) {
    height: 36px;
    line-height: 36px;
  }
  ul li:last-child {
    height: 36px;
    line-height: 36px;
  }
  .active {
    // background: linear-gradient(
    //   49deg,
    //   rgba(253, 29, 29, 1) 0%,
    //   rgba(255, 248, 248, 1) 100%,
    //   rgba(255, 255, 255, 1) 100%
    // );
    background-color: #fd1d1d;
    color: white;
  }
}
/deep/.el-carousel__button {
  width: 8px;
}
/deep/.el-carousel__indicator--horizontal {
  padding: 8px 6px;
}
/deep/.el-carousel__item.is-active {
  z-index: 0;
}
/deep/.el-carousel__indicator.is-active button {
  width: 16px;
}
</style>
